import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trainingModules } from '../../data/trainingModules';

const { FiX, FiCheck, FiAward, FiTrendingDown } = FiIcons;

const CompleteRemediationModal = ({ record, onClose, onComplete }) => {
  const [score, setScore] = useState(80);
  const module = trainingModules.find(m => m.id === record.assignedModuleId);
  const riskDelta = score >= 80 ? -10 : score >= 60 ? -5 : 0;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
        <motion.div initial={{ opacity: 0, scale: 0.96, y: 16 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }}
          className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md z-10">

          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
            <div>
              <h2 className="text-base font-semibold text-slate-800">Complete Remediation</h2>
              <p className="text-xs text-slate-500 mt-0.5">{module?.title}</p>
            </div>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600 p-1 rounded-lg hover:bg-slate-100">
              <SafeIcon icon={FiX} />
            </button>
          </div>

          <div className="px-6 py-5 space-y-5">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                Assessment Score: <span className={`${score >= 80 ? 'text-emerald-600' : score >= 60 ? 'text-yellow-600' : 'text-red-600'}`}>{score}%</span>
              </label>
              <input type="range" min={0} max={100} value={score} onChange={e => setScore(Number(e.target.value))}
                className="w-full accent-blue-600 cursor-pointer" />
              <div className="flex justify-between text-xs text-slate-400 mt-1">
                <span>0%</span><span>50%</span><span>100%</span>
              </div>
            </div>

            <div className={`rounded-xl p-4 border space-y-2 ${score >= 80 ? 'bg-emerald-50 border-emerald-200' : score >= 60 ? 'bg-yellow-50 border-yellow-200' : 'bg-red-50 border-red-200'}`}>
              <div className="flex items-center gap-2 text-sm font-semibold">
                <SafeIcon icon={score >= 80 ? FiAward : FiCheck} className={score >= 80 ? 'text-emerald-600' : score >= 60 ? 'text-yellow-600' : 'text-red-600'} />
                <span className={score >= 80 ? 'text-emerald-700' : score >= 60 ? 'text-yellow-700' : 'text-red-700'}>
                  {score >= 80 ? 'Passed — Excellent!' : score >= 60 ? 'Passed — Adequate' : 'Failed — Retraining Needed'}
                </span>
              </div>
              {riskDelta !== 0 && (
                <div className="flex items-center gap-1.5 text-xs text-emerald-700">
                  <SafeIcon icon={FiTrendingDown} />Risk score will decrease by {Math.abs(riskDelta)} pts
                </div>
              )}
              <p className="text-xs text-slate-600">
                {score >= 80 ? 'Learner status will be reset to Compliant.' : score >= 60 ? 'Learner status updated to In Progress.' : 'No risk adjustment. Consider reassigning.'}
              </p>
            </div>
          </div>

          <div className="flex gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl">
            <button onClick={onClose} className="flex-1 py-2.5 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700 hover:bg-slate-100 transition-colors">
              Cancel
            </button>
            <button onClick={() => onComplete(record.id, score)}
              className="flex-1 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors flex items-center justify-center gap-2">
              <SafeIcon icon={FiCheck} />Confirm Completion
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default CompleteRemediationModal;